module.exports = __webpack_public_path__ + "static/img/dev_p2.93a822f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developerCommunity/dev_p2.png
// module id = Fm9I
// module chunks = 19